<template>
    <div>
        <div class="crumbs">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item>
                    <i class="el-icon-lx-cascades"></i> 监控记录
                </el-breadcrumb-item>
            </el-breadcrumb>
        </div>

        <div class="container">
            <div>
                <div class="handle-headright">
                    <el-date-picker v-model="query.daterange" type="daterange" align="right" unlink-panels range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" :picker-options="pickerOptions" class="handle-select mr10" style="width: 300px"></el-date-picker>
                    <el-select v-model="query.Field1" placeholder="事件类型" class="handle-select mr10" @change="getData">
                        <el-option v-for="item in balanceArr" :key="item" :label="item" :value="item"></el-option>
                    </el-select>
                    <el-button type="primary" icon="el-icon-search" @click="getData">搜索</el-button>
                </div>
            </div>
            <el-table :data="frequencys" border class="table" ref="multipleTable" element-loading-text="玩命加载中..." v-loading="loading" header-cell-class-name="table-header">
                <el-table-column type="index" width="50" label="序号"></el-table-column>
                <el-table-column sortable prop="createDate" label="报警时间" width="150">
                    <template slot-scope="scope">
                        <i class="el-icon-time"></i>
                        {{ scope.row.createDate | formateData }}
                    </template>
                </el-table-column>
                <el-table-column sortable prop="eventType" label="报警事件" width="150"></el-table-column>
                <el-table-column sortable prop="remark" label="报警信息"></el-table-column>
                <!-- <el-table-column prop="imgSrc" label="显示图片"></el-table-column> -->
                <!-- <el-table-column prop="" label="图片" width="80">
                    <template >
                        <img style="width: 60px; height: 60px" src="localhost:8085\picture\UserID_0_行为分析_210715152405014.jpg" alt="" />
                    </template>
                </el-table-column>-->
                <el-table-column label="操作" width="110" align="center">
                    <template slot-scope="scope">
                        <el-button type="text" icon="el-icon-edit" @click="handleShowImg(scope.row.id, scope.row)">查看</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <div class="pagination">
                <el-pagination background layout="total, prev, pager, next" :current-page="query.PageIndex" :page-size="query.PageSize" :total="pageCount" @current-change="handlePageChange"></el-pagination>
            </div>
        </div>
        <!-- 查看弹出框 -->
        <el-dialog title="查看详情" :visible.sync="viewVisible" width="40%" :close-on-click-modal="false">
            <el-form :model="entity" label-width="90px">
                <el-row>
                    <el-col :span="12">
                        <el-form-item label="报警事件" prop="eventType">
                            <span v-text="entity.eventType"></span>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="报警时间" prop="createDate">
                            <span>{{ entity.createDate | formateData }}</span>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="24">
                        <el-form-item label="报警信息" prop="remark">
                            <span v-text="entity.remark"></span>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="24">
                        <el-image :src="entity.imgSrc" alt></el-image>
                    </el-col>
                </el-row>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="viewVisible = false">关 闭</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import { dateFormat, SortField } from '../../utils/helper';
import { API } from '../../../public/config';
let that;
export default {
    name: 'frequency',
    data: function () {
        return {
            pickerOptions0: {
                disabledDate(time) {
                    return time.getTime() > Date.now(); //如果没有后面的-8.64e7就是不可以选择今天的
                }
            },
            balanceArr: [],
            frequencys: [],
            entity: {},
            pageCount: 1,
            viewVisible: false,
            multipleSelection: [],
            loading: false,
            query: {
                startDate: '',
                endDate: '',
                daterange: '',
                daterange: '',
                Field1: '',
                PageIndex: 1,
                PageSize: 15
            },
            fit: ['fill', 'contain', 'cover', 'none', 'scale-down'],
            url: 'https://picabstract-preview-ftn.weiyun.com/ftn_pic_abs_v3/61da3bff5d6ed96d08e81c688584f5530960272fc417baa8e5c6da19ac0097e33ae5ff23fe6e09743ddc27c11d9359a7?pictype=scale&from=30113&version=3.3.3.3&uin=3300123770&fname=EG9A1384.jpg&size=750',
            pickerOptions: {
                disabledDate(time) {
                    return time.getTime() > Date.now(); //如果没有后面的-8.64e7就是不可以选择今天的
                },
                shortcuts: [
                    {
                        text: '最近一周',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                            picker.$emit('pick', [start, end]);
                        }
                    },
                    {
                        text: '最近一个月',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                            picker.$emit('pick', [start, end]);
                        }
                    },
                    {
                        text: '最近三个月',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
                            picker.$emit('pick', [start, end]);
                        }
                    }
                ]
            }
        };
    },
    created() {
        const end = new Date();
        const start = new Date();
        start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
        this.query.daterange = [start, end];

        this.getData();
        this.getBalance();
    },

    methods: {
        getData() {
            if (this.query.daterange == null) {
                this.$notify.warning('日期不能为空!!!');
                return;
            }
            this.query.startDate = new Date(dateFormat.formatDate(this.query.daterange[0], 'yyyy-MM-dd 08:00:00'));
            this.query.endDate = new Date(dateFormat.formatDate(this.query.daterange[1], 'yyyy-MM-dd 08:00:00'));
            this.$zybhttp
                .post('DataInquiry/GetEventList', this.query)
                .then((res) => {
                    if (res.data.status == 0) {
                        res = res.data;
                        var d = res.data.list;
                        var newdata = d.sort(SortField('id', 'desc'));
                        // for (var i = 0; i < newdata.length; i++) {
                        //     newdata[i]['balanceName'] = this.getBalanceNames(newdata[i]['balanceId']);
                        // }
                        this.frequencys = newdata;
                        this.pageCount = res.data.total || 0;
                    } else {
                        this.$notify.error(res.message);
                    }
                })
                .catch((err) => this.$notify.error('网络异常！获取列表失败！'));
        },
        handleShowImg(id, row) {
            var d = JSON.parse(JSON.stringify(row));
            this.viewVisible = true;
            this.entity = d;
            let baseUrl = '';
            if (process.env.NODE_ENV == 'development') {
                // 开发环境的url
                baseUrl = API.DEV_SERVER;
            } else if (process.env.NODE_ENV == 'production') {
                // 正式环境的 request url
                // baseUrl = API.PRO_SERVER
                baseUrl = 'http://' + window.location.host;
            }
            this.entity.imgSrc = this.entity.imgSrc.replace('.\\', baseUrl + '\\');
        },
        getBalance() {
            var serach = {};
            this.$zybhttp
                .post('DataInquiry/GetEventType', {})
                .then((res) => {
                    if (res.data.status == 0) {
                        var d = res.data.data.list;
                        this.balanceArr = ['全部'].concat(d);
                        this.getData();
                    } else {
                        this.$notify.error(res.message);
                    }
                })
                .catch((err) => this.$notify.error('网络异常！获取列表失败！'));
        },

        handlePageChange(val) {
            this.$set(this.query, 'PageIndex', val);
            this.getData();
        },

        indexMethod(index) {
            return index + 1;
        }
    }
};
</script>

<style scoped>
.handle-box {
    margin-bottom: 20px;
}

.handle-select {
    width: 200px;
}

.handle-headleft {
    float: left;
    margin-bottom: 15px;
}
.handle-headright {
    float: right;
    margin-bottom: 15px;
}

.handle-input {
    width: 300px;
    display: inline-block;
}

.table {
    width: 100%;
    font-size: 14px;
}

.red {
    color: #ff0000;
}

.mr10 {
    margin-right: 10px;
}

.table-td-thumb {
    display: block;
    margin: auto;
    width: 40px;
    height: 40px;
}

.size-full {
    width: 100%;
}
</style>
